// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"9c102873","91":"7a48e871","477":"34bd594b"}[chunkId] + ".chunk.js";
};